import { ReplaySubject, Observable } from "rxjs";
import { DataService } from "@ramyhhh/data";
import { map, switchMap } from "rxjs/operators";
import { ITableDataSource, ProviderOptions, PageDescriptor, SortDescriptor, TableDataSource, Term } from "./model";


export class ServerDataSource<T = any> extends TableDataSource<T> {


    readonly allDataLoaded = false;

    data: T[];
    readonly src$ = new ReplaySubject<Observable<T[]>>(1);
    readonly data$ = this.src$.pipe(switchMap(src => src)); //everytime the src is changed switch to the new one



    constructor(private readonly dataService: DataService, private readonly path: string, private readonly selectedColumns: (keyof T)[]) {
        super();
    }


    _evalTerm(term: Term<T>, value: string) {
        switch (term.type) {
            case 'like': return `*${value}*`;
            case 'number': return +value;
            case 'boolean': return value == 'true';
            case 'date': return new Date(value);
            default: return value;
        }
    }

    refresh(): Observable<T[]> {

        const filter = this.filter;
        const sort = this.sort;
        const page = this.page;

        const query: any = {}
        let term: any = (filter && filter.terms?.length) ? filter.terms.join(" ") : '';
        if (term) {
            const termsFields = this.terms.slice();
            if (termsFields.length) {
                const k = termsFields.shift();
                query[k.field] = this._evalTerm(k, term);
                if (termsFields.length) query[k.field] += '|' + termsFields.map(f => `${f.field}=${this._evalTerm(f, term)}`).join("|");
            }
        }
        Object.keys(filter).forEach(k => query[k] = filter[k]);
        delete query.terms;

        query.page = page.pageIndex + 1;
        query.per_page = page.pageSize;

        if (sort?.active) query.sort_by = `${sort.active},${sort.direction}`;

        if (this.selectedColumns?.length > 0) query.select = this.selectedColumns.join(',');

        const src = this.dataService.fetch<T[]>(this.path, query, { "X-Get": 'Count' })
            .pipe(map(x => {
                page.length = x.meta == null || isNaN(+x.meta.count) ? 0 : +x.meta.count;
                this.data = x.data;
                return x.data;
            }));

        this.src$.next(src);
        return this.data$;
    }

    destroy?() { }


}

